import Vue from "vue";
import store from "../../vuex/store";

export const getBasket = ({ dispatch }) => {
  dispatch("LOADING");
  Vue.http.get("api/v1/Basket").then(function (response) {
    getBasketPartial({dispatch});
    dispatch("BASKET_LOADED", response.data);
    console.log("Basket uuuu");
  });
};

export const getBasketPartial = ({ dispatch }) => {
  Vue.http.get("api/v1/Basket/Partial").then(function (response) {
    dispatch("BASKET_PARTIAL_LOADED", response.data);
  });
};

export const getSelected = () => {
  var selected = [];

  for (var i = 0; i < store.state.basket.Files.length; i++) {
    for (var j = 0; j < store.state.basket.Files[i].Items.length; j++) {
      if (store.state.basket.Files[i].Items[j].selected) {
        selected.push(store.state.basket.Files[i].Items[j].Id);
      }
    }
  }

  return selected;
};

export const selectAll = ({ dispatch }) => {
  dispatch("BASKET_SELECT_ALL");
};

export const emailSelected = ({ dispatch }) => {
  Vue.http.post("api/v1/Basket/SendEmail", getSelected()).then(function (response) {
    dispatch("BASKET_EMAIL_SELECTED");
    dispatch("MAIL_SENT");
  });
};

export const downloadSelected = ({ dispatch }) => {
  dispatch("DOWNLOAD", "/api/v1/Basket/Download", {Id: JSON.stringify(getSelected())});
};

export const deleteSelected = ({ dispatch }) => {
  dispatch("LOADING_BASKET");
  Vue.http.delete("api/v1/Basket", JSON.stringify(getSelected())).then(function (response) {
    getBasket({dispatch});
    dispatch("BASKET_DELETE_SELECTED");
  });
};

export const deleteItem = ({ dispatch }, id) => {
  dispatch("LOADING_BASKET");
  Vue.http.delete("api/v1/Basket", JSON.stringify([id])).then(function (response) {
    getBasket({dispatch});
    dispatch("BASKET_DELETE_SELECTED");
  });
};

export const updateItem = ({ dispatch }, item, value) => {
  dispatch("BASKET_ITEM_UPDATE", item, value);
};



// WEBPACK FOOTER //
// ./src/views/basket/BasketActions.js